import ConnectedToggle from "components/screener/shared/ConnectedToggle";

export default function IsAmericanDepositaryReceipt() {
  return (
    <div className="space-y-2">
      <h3 className="font-aeonik text-base font-bold tracking-wide text-zinc-500">ADRs</h3>

      <div className="flex items-center justify-between">
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Filtre por Stocks que são ADRs
        </span>

        <ConnectedToggle label="BDRs" attribute="isAmericanDepositaryReceipt" value={true} />
      </div>
    </div>
  );
}
